import { render, staticRenderFns } from "./SalesOrdersPage.vue?vue&type=template&id=291f4850&scoped=true&"
import script from "./SalesOrdersPage.vue?vue&type=script&lang=js&"
export * from "./SalesOrdersPage.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrdersPage.vue?vue&type=style&index=0&id=291f4850&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291f4850",
  null
  
)

export default component.exports